import React from 'react';
import { AwardIcon, UsersIcon, CheckCircleIcon, ShieldIcon } from 'lucide-react';
import { ServiceAreaMap } from './ServiceAreaMap';
export const AboutSection = () => {
  return <section id="about" className="py-16 bg-gradient-to-b from-white to-blue-50" data-id="element-16">
      <div className="container mx-auto px-4" data-id="element-17">
        <div className="text-center mb-12" data-id="element-18">
          <span className="inline-block px-4 py-1.5 rounded-full bg-blue-100 text-blue-700 font-semibold text-sm mb-4" data-id="element-19">
            ABOUT US
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-5" data-id="element-20">
            About AIR-MAZING AIR, INC.
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-21">
            With over 10 years of experience, we've been delivering exceptional
            HVAC services to homeowners and businesses throughout Southwest
            Florida.
          </p>
        </div>
        {/* Service Area Map */}
        <div className="mb-16" data-id="element-22">
          <h3 className="text-2xl font-bold text-center mb-6 text-gray-800" data-id="element-23">
            Our Service Area
          </h3>
          <ServiceAreaMap data-id="element-24" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16" data-id="element-25">
          <div className="bg-white rounded-xl shadow-lg p-7 text-center transform transition-transform hover:scale-105 duration-300" data-id="element-26">
            <div className="flex justify-center mb-5" data-id="element-27">
              <div className="bg-blue-100 p-4 rounded-full" data-id="element-28">
                <AwardIcon size={48} className="text-blue-600" data-id="element-29" />
              </div>
            </div>
            <h3 className="text-xl font-bold mb-3 text-gray-800" data-id="element-30">
              10+ Years Experience
            </h3>
            <p className="text-gray-600" data-id="element-31">
              A decade of providing top-quality HVAC services to our valued
              customers.
            </p>
          </div>
          <div className="bg-white rounded-xl shadow-lg p-7 text-center transform transition-transform hover:scale-105 duration-300" data-id="element-32">
            <div className="flex justify-center mb-5" data-id="element-33">
              <div className="bg-blue-100 p-4 rounded-full" data-id="element-34">
                <UsersIcon size={48} className="text-blue-600" data-id="element-35" />
              </div>
            </div>
            <h3 className="text-xl font-bold mb-3 text-gray-800" data-id="element-36">
              Certified Technicians
            </h3>
            <p className="text-gray-600" data-id="element-37">
              Our team is fully licensed, insured, and certified to handle all
              your HVAC needs.
            </p>
          </div>
          <div className="bg-white rounded-xl shadow-lg p-7 text-center transform transition-transform hover:scale-105 duration-300" data-id="element-38">
            <div className="flex justify-center mb-5" data-id="element-39">
              <div className="bg-blue-100 p-4 rounded-full" data-id="element-40">
                <CheckCircleIcon size={48} className="text-blue-600" data-id="element-41" />
              </div>
            </div>
            <h3 className="text-xl font-bold mb-3 text-gray-800" data-id="element-42">
              Quality Guaranteed
            </h3>
            <p className="text-gray-600" data-id="element-43">
              We stand behind our work with satisfaction guarantees and
              comprehensive warranties.
            </p>
          </div>
          <div className="bg-white rounded-xl shadow-lg p-7 text-center transform transition-transform hover:scale-105 duration-300" data-id="element-44">
            <div className="flex justify-center mb-5" data-id="element-45">
              <div className="bg-blue-100 p-4 rounded-full" data-id="element-46">
                <ShieldIcon size={48} className="text-blue-600" data-id="element-47" />
              </div>
            </div>
            <h3 className="text-xl font-bold mb-3 text-gray-800" data-id="element-48">
              Trusted Service
            </h3>
            <p className="text-gray-600" data-id="element-49">
              Highly rated on Facebook, Thumbtack, and Nextdoor by our satisfied
              customers.
            </p>
          </div>
        </div>
        <div className="bg-white rounded-xl shadow-xl p-8 md:p-10" data-id="element-50">
          <h3 className="text-2xl font-bold mb-6 text-blue-700" data-id="element-51">
            Our Commitment to You
          </h3>
          <p className="text-lg mb-8 text-gray-600 leading-relaxed" data-id="element-52">
            At AIR-MAZING AIR, INC., we're committed to providing exceptional
            service and solutions for all your heating and cooling needs. We
            believe in:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-53">
            <div className="flex items-start bg-gray-50 p-4 rounded-lg" data-id="element-54">
              <CheckCircleIcon className="h-6 w-6 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-55" />
              <p data-id="element-56">Transparent pricing with no hidden fees or surprises</p>
            </div>
            <div className="flex items-start bg-gray-50 p-4 rounded-lg" data-id="element-57">
              <CheckCircleIcon className="h-6 w-6 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-58" />
              <p data-id="element-59">Prompt, professional service at every appointment</p>
            </div>
            <div className="flex items-start bg-gray-50 p-4 rounded-lg" data-id="element-60">
              <CheckCircleIcon className="h-6 w-6 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-61" />
              <p data-id="element-62">Using only high-quality parts and equipment</p>
            </div>
            <div className="flex items-start bg-gray-50 p-4 rounded-lg" data-id="element-63">
              <CheckCircleIcon className="h-6 w-6 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-64" />
              <p data-id="element-65">Respecting your home or business during every visit</p>
            </div>
            <div className="flex items-start bg-gray-50 p-4 rounded-lg" data-id="element-66">
              <CheckCircleIcon className="h-6 w-6 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-67" />
              <p data-id="element-68">Providing honest recommendations without upselling</p>
            </div>
            <div className="flex items-start bg-gray-50 p-4 rounded-lg" data-id="element-69">
              <CheckCircleIcon className="h-6 w-6 text-green-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-70" />
              <p data-id="element-71">Ongoing training for our technicians to stay current</p>
            </div>
          </div>
          <div className="mt-8 text-center" data-id="element-72">
            <a href="#request-service" className="inline-block bg-blue-600 hover:bg-blue-700 text-white px-10 py-4 rounded-md font-bold text-lg transition-all duration-300 shadow-lg transform hover:-translate-y-1" data-id="element-73">
              Experience the AIR-MAZING Difference
            </a>
          </div>
        </div>
      </div>
    </section>;
};